import { RoundButton, styled, toast, Modal, Button } from '@fareye/ui'
import { cancelToken, getQueryParams, post, FaTrash } from '@fareye/utils'
import React from 'react'

interface IUpdateAlertStatusButton {
  alert: any
  selectedAlert: any
  setSelectedAlert(val: any): void
  config: any
}

const SubscribeIcon = styled(RoundButton)`
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.3);
  transition: 0.2s ease;
  margin: -4px 0;
  &:hover {
    transition: 0.6s ease;
    box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.3);
  }
`

export function UpdateAlertStatusButton({
  alert,
  config,
  setSelectedAlert
}: IUpdateAlertStatusButton) {
  const source = cancelToken().source()
  const [showConfirm, setShowConfirm] = React.useState(false)

  async function updateAlertStatus() {
    try {
      let updateStatus = 'disable'
      const { apiURL: BASE_URL } = config.config.apiConfig
      const queryParam = getQueryParams({ action_type: updateStatus })
      const apiUrl = `${BASE_URL}/${alert.id}/manage?${queryParam}`
      const resp = await post(apiUrl, {}, source.token)
      toast.success('Deleted successfully...')
      setSelectedAlert(resp?.data)
    } catch (ex:any) {
      toast.error('Failed to delete. Please try again.')
    }
  }

  return (
    <>
      <SubscribeIcon
        title={'Delete'}
        variant={'primary s'}
        onClick={() => setShowConfirm(true)}
      >
        <FaTrash />
      </SubscribeIcon>
      <Modal
        toggleModal={showConfirm}
        setToggleModal={setShowConfirm}
        style={{
          content: {
            maxWidth: '420px',
            padding: '24px',
            borderRadius: '8px'
          }
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <p
            style={{
              fontSize: '16px',
              fontWeight: 600,
              marginBottom: '8px',
              color: '#333'
            }}
          >
            Delete Alert
          </p>
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '24px' }}>
            Are you sure you want to delete this alert?
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '12px'
            }}
          >
            <Button
              variant={'default m'}
              onClick={() => setShowConfirm(false)}
            >
              No
            </Button>
            <Button
              variant={'danger m'}
              onClick={() => {
                setShowConfirm(false)
                updateAlertStatus()
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
